import { useEffect, useRef, useState } from 'react'
import { useNavigation } from 'react-router'

const SHOW_DELAY_MS = 180
const MIN_VISIBLE_MS = 400

export function NavigationProgress() {
  const navigation = useNavigation()
  const isNavigating = navigation.state !== 'idle'

  const [isVisible, setIsVisible] = useState(false)
  const shownAtRef = useRef(0)

  useEffect(() => {
    if (isNavigating) {
      if (isVisible) return

      const timeout = setTimeout(() => {
        shownAtRef.current = Date.now()
        setIsVisible(true)
      }, SHOW_DELAY_MS)

      return () => clearTimeout(timeout)
    }

    if (!isVisible) return

    // Once shown, the bar stays at least MIN_VISIBLE_MS so a navigation that
    // ends right after the delay does not flash it for a few frames.
    const elapsed = Date.now() - shownAtRef.current
    const timeout = setTimeout(
      () => setIsVisible(false),
      Math.max(0, MIN_VISIBLE_MS - elapsed),
    )

    return () => clearTimeout(timeout)
  }, [isNavigating, isVisible])

  if (!isVisible) {
    return null
  }

  return (
    <div
      role="progressbar"
      aria-busy="true"
      aria-label="Loading page"
      className="fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden bg-fintalk/15"
    >
      <div className="h-full w-1/4 animate-route-progress bg-fintalk" />
    </div>
  )
}
